/** 后端 API 根路径（开发走 vue proxy，生产指向网关） */
export const API_BASE = process.env.VUE_APP_API_BASE || '/api/v1'

/** 从验证码接口响应解析 img src（兼容 imageBase64 与 imageUrl） */
export function resolveCaptchaImage(data) {
  if (!data?.captchaId) return ''
  if (data.imageBase64) {
    const raw = String(data.imageBase64).trim()
    if (raw.startsWith('data:')) return raw
    return `data:image/png;base64,${raw}`
  }
  return buildCaptchaImageUrl(data.captchaId, data.imageUrl)
}

/** 拼接验证码图片完整 URL（img src） */
export function buildCaptchaImageUrl(captchaId, imageUrl) {
  const path = imageUrl || `/api/v1/auth/captcha/${captchaId}/image`
  const ts = `t=${Date.now()}`

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path.includes('?') ? `${path}&${ts}` : `${path}?${ts}`
  }

  const apiBase = API_BASE.replace(/\/$/, '')

  // 服务端返回的 imageUrl 已含 /api/v1 前缀
  if (path.startsWith('/api/')) {
    if (apiBase.startsWith('http://') || apiBase.startsWith('https://')) {
      const origin = apiBase.replace(/\/api\/v1$/, '')
      return `${origin}${path}?${ts}`
    }
    return `${path}?${ts}`
  }

  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${apiBase}${normalized}?${ts}`
}
